// lib/passwortRegel.js — EINE Passwortregel für alle Konten (25.10.2026)
//
// Bis heute galten drei Regeln nebeneinander: die Registrierungsseite
// verlangte 6 Zeichen, die Prüfung davor 6 Zeichen plus Groß-, Kleinbuchstabe
// und Zahl, der Controller 8 Zeichen plus dasselbe. Zurücksetzen,
// Admin-Passwort und Personal-Einladung verlangten nur 8 Zeichen. Wer die
// Seite befolgte, scheiterte am Server mit „Validierungsfehler“.
//
// Gilt jetzt überall, wo ein Mensch ein Passwort wählt: Vereinsregistrierung,
// Passwort zurücksetzen, Admin setzt/legt an, Athletenkonto, Personal-Zugang.
// Die strengste vorhandene Regel (authController bis 25.10.2026).
//
// ⚠️ Abschrift von backend/utils/passwortRegel.js — der Test
// utils/__tests__/passwortRegel.test.js vergleicht beide.

const PASSWORT_REGELN = [
  { id: 'laenge', text: 'Mindestens 8 Zeichen', test: (pw) => pw.length >= 8 },
  { id: 'gross', text: 'Ein Großbuchstabe', test: (pw) => /[A-ZÄÖÜ]/.test(pw) },
  { id: 'klein', text: 'Ein Kleinbuchstabe', test: (pw) => /[a-zäöüß]/.test(pw) },
  { id: 'zahl', text: 'Eine Zahl', test: (pw) => /[0-9]/.test(pw) },
];

/** Welche Regeln erfüllt das Passwort nicht? Liste der Regeln (leer = gut). */
function passwortOffen(passwort) {
  const pw = typeof passwort === 'string' ? passwort : '';
  return PASSWORT_REGELN.filter((r) => !r.test(pw));
}

/** Ein Satz für die Fehlermeldung am Feld, oder null, wenn alles passt. */
function passwortFehler(passwort) {
  const offen = passwortOffen(passwort);
  if (!offen.length) return null;
  return `Das Passwort braucht noch: ${offen.map((r) => r.text.charAt(0).toLowerCase() + r.text.slice(1)).join(', ')}`;
}

export { PASSWORT_REGELN, passwortOffen, passwortFehler };
